import { CallState, LoadingState } from '@lcs/shared/api';
import { Action, createReducer, on } from '@ngrx/store';
import { onReset } from 'src/app/authentication/reset-reducer';
import * as AddProviderCallCostActions from './add-provider-call-costs.actions';

export const addProviderCallCostFeatureKey = 'addProviderCallCost';

export interface AddProviderCallCostState {
   callState: CallState;
}

export const initialState: AddProviderCallCostState = {
   callState: LoadingState.Init,
};

const addProviderCallCostReducer = createReducer(
   initialState,
   onReset(initialState),
   on(AddProviderCallCostActions.createProviderCallCostPreview, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
      };
   }),
   on(AddProviderCallCostActions.createProviderCallCost, (state) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
      };
   }),
   on(AddProviderCallCostActions.createProviderCallCostUpload, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
      };
   }),
   on(AddProviderCallCostActions.createProviderCallCostSuccess, (state) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
      };
   }),
   on(AddProviderCallCostActions.createProviderCallCostFailure, (state) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
      };
   })
);

export function reducer(state: AddProviderCallCostState | undefined, action: Action) {
   return addProviderCallCostReducer(state, action);
}
